import graphqlRequest from "Services/assignment/assignmentRequest";
import UPDATE_MANIFEST from "./graphql";

export async function updateManifest(input) {
  const response = await graphqlRequest(UPDATE_MANIFEST, {input});
  return response
}

export async function skipActivityInManifest(assignmentId,activityType,locale){
  let input = {assignmentId,activityType,locale,status: "DONE"};
  console.log("SKIPPING",input); //leave this in for troubleshooting.
  await updateManifest(input);
}
